import { useEffect, ComponentType } from 'react';
import { connect } from 'react-redux';
import { PapiUser } from '@wix/da-papi-types';
import { getArtAuthor } from './redux/selectors';
import { fetchArtAuthor as fetchArtAuthorAction } from './redux/actions';

export interface WithPopupArtProps {
  artImageSrc?: string;
  artAuthorUsername?: string;
  artAuthor?: PapiUser;
  fetchArtAuthor?: any;
}

export type StateProps = Pick<WithPopupArtProps, 'artAuthor'>;
export type DispatchProps = Pick<WithPopupArtProps, 'fetchArtAuthor'>;
export type OwnProps = Omit<WithPopupArtProps, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state, ownProps): StateProps => ({
  artAuthor: ownProps.artAuthor || getArtAuthor(state),
});

const mapDispatchToProps: DispatchProps = {
  fetchArtAuthor: fetchArtAuthorAction,
};

function wrapComponent<TProps>(Component: ComponentType<TProps & WithPopupArtProps>) {
  // tslint:disable-next-line only-arrow-functions
  return function WrapperComponent({
    artImageSrc,
    artAuthor,
    artAuthorUsername,
    fetchArtAuthor,
    ...props
  }) {
    // Load art author user data on the first render.
    // If we're not in production, use chris as the username to avoid
    // getting an error due to inexistent user data.
    useEffect(() => {
      !artAuthor &&
        fetchArtAuthor &&
        artAuthorUsername &&
        fetchArtAuthor({
          username: process.env.NODE_ENV === 'development' ? 'chris' : artAuthorUsername,
        });
    });

    return <Component artImageSrc={artImageSrc} artAuthor={artAuthor} {...(props as TProps)} />;
  };
}

export default function withPopupArt<TProps>(component: ComponentType<TProps & WithPopupArtProps>) {
  return connect(mapStateToProps, mapDispatchToProps)(wrapComponent(component));
}
